<script setup>
import TableHeaderRow from "@/components/global-themed/table/TableHeaderRow.vue";
import TableHeaderCell from "@/components/global-themed/table/TableHeaderCell.vue";
import DataTable from "@/components/global-themed/table/DataTable.vue";
import {useStore} from "vuex";
import {computed} from "vue";
import TableBody from "@/components/global-themed/table/TableBody.vue";
import BacklinkRow from "@/components/competition/partials/backlinks/BacklinkRow.vue";
import ZeroContent from "@/components/global-themed/ZeroContent.vue";

const store = useStore();

const orderBy = computed(() => store.getters['competitionV2/backlinksOrderBy']);
const orderDirection = computed(() => store.getters['competitionV2/backlinksOrderDirection']);

const changeOrderBy = (name) => {
  store.dispatch('competitionV2/setBacklinksOrder', name)
}

const backlinks = computed(() => store.getters["competitionV2/filteredBacklinks"]);

const view = computed(() => store.getters['competitionV2/backlinksView']);

</script>

<template>
  <div>
    <DataTable>
      <TableHeaderRow class="tw-grid-cols-16">
        <TableHeaderCell
          v-if="view === 'simple'"
          col-span="4"
          :order-by="orderBy"
          :order-direction="orderDirection"
          name="domain"
          @order-changed="changeOrderBy"
        >
          <span>Domain</span>
        </TableHeaderCell>

        <TableHeaderCell
          :col-span="view === 'simple' ? 5 : 4"
          :order-by="orderBy"
          :order-direction="orderDirection"
          name="url"
          @order-changed="changeOrderBy"
        >
          <span>URL</span>
        </TableHeaderCell>

        <TableHeaderCell
          :order-by="orderBy"
          :order-direction="orderDirection"
          name="domainAuthority"
          col-span="2"
          class="tw-justify-center tw-text-center tw-px-1"
          @order-changed="changeOrderBy"
        >
          <span>Domain Authority</span>
        </TableHeaderCell>

        <TableHeaderCell
          :order-by="orderBy"
          :order-direction="orderDirection"
          name="pageAuthority"
          col-span="2"
          class="tw-justify-center tw-text-center tw-px-1"
          @order-changed="changeOrderBy"
        >
          <span>Page Authority</span>
        </TableHeaderCell>

        <TableHeaderCell
          col-span="2"
          :order-by="orderBy"
          :order-direction="orderDirection"
          name="found"
          @order-changed="changeOrderBy"
        >
          <span>Date Found</span>
        </TableHeaderCell>
        <TableHeaderCell
          v-if="view === 'advanced'"
          :order-by="orderBy"
          :order-direction="orderDirection"
          name="followType"
          col-span="2"
          @order-changed="changeOrderBy"
        >
          <span>Follow Type</span>
        </TableHeaderCell>

        <TableHeaderCell
          v-if="view === 'advanced'"
          col-span="2"
          :order-by="orderBy"
          :order-direction="orderDirection"
          name="anchorText"
          @order-changed="changeOrderBy"
        >
          <span>Anchor Text</span>
        </TableHeaderCell>

        <TableHeaderCell
          v-if="view === 'advanced'"
          :order-by="orderBy"
          :order-direction="orderDirection"
          name="linkType"
          col-span="2"
          @order-changed="changeOrderBy"
        >
          <span>Link Type</span>
        </TableHeaderCell>
      </TableHeaderRow>

      <TableBody
        v-if="backlinks.length > 0"
        class="tw-max-h-[70vh]"
      >
        <BacklinkRow
          v-for="backlink in backlinks"
          :key="backlink.url"
          :backlink="backlink"
        />
      </TableBody>
      <ZeroContent v-if="!backlinks.length">
        Looks like there are no <br>backlinks to display.
      </ZeroContent>
    </DataTable>
  </div>
</template>
